export default __webpack_public_path__ + "static/media/dreamstime_s_107263084.8bd1d382.jpg";